/* eslint-disable camelcase */
import api from '../../api'

export default {
  namespaced: true,
  state: {
    places: []
  },
  getters: {
    getplaces: state => state.places
  },
  mutations: {
    SET_PLACES: (state, data) => {
      state.places = data
    }
  },
  actions: {
    async getPlaces (context) {
      const res = await api.getPlaces()
      if (res && res.data) {
        context.commit('SET_PLACES', res.data)
        return res
      }
      throw new Error(res)
    }
  }
}
